module.exports = __webpack_public_path__ + "static/media/Quick-Pick.2bdaf754.png";